import { sentryPages } from "~/utils/sentry/sentry-pages";

export default defineNuxtRouteMiddleware(async ({ path }) => {
  const config = useRuntimeConfig();

  if (
    !process.client ||
    !sentryPages.some((page) => path.includes(page)) ||
    !config.public.SENTRY_DSN_PUBLIC
  ) {
    return;
  }

  const VueSentry = await import("@sentry/vue");

  if (VueSentry.isInitialized()) {
    return;
  }

  const router = useRouter();
  const nuxtApp = useNuxtApp();

  VueSentry.init({
    app: nuxtApp.vueApp,
    dsn: config.public.SENTRY_DSN_PUBLIC ?? undefined,
    integrations: [
      VueSentry.browserTracingIntegration({ router }),
      VueSentry.replayIntegration(),
      VueSentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: config.public.SENTRY_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: config.public.SENTRY_REPLAY_SAMPLE_RATE,
    replaysOnErrorSampleRate: config.public.SENTRY_ERROR_REPLAY_SAMPLE_RATE,
  });
});
